import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexQueryClient } from "@convex-dev/react-query";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConvexReactClient } from "convex/react";
import type { ReactNode } from "react";

const convexUrl = import.meta.env.VITE_CONVEX_URL;
console.debug("Convex URL:", convexUrl);

if (!convexUrl) {
  throw new Error("VITE_CONVEX_URL is not set");
}

console.debug("Initializing Convex client with URL:", convexUrl);

const convex = new ConvexReactClient(convexUrl);
const convexQueryClient = new ConvexQueryClient(convex);
export const convexClient = convex;

function getContext() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        queryKeyHashFn: convexQueryClient.hashFn(),
        queryFn: convexQueryClient.queryFn(),
        // Disable all React Query automatic refetching - Convex subscriptions handle updates
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        // Use Convex subscriptions for real-time updates instead of polling
        // Setting staleTime to Infinity ensures we rely on subscriptions
        staleTime: Infinity,
        // Don't retry failed requests automatically - let Convex handle connection
        retry: false,
      },
    },
  });
  return {
    queryClient,
  };
}

export const queryContext = getContext();

convexQueryClient.connect(queryContext.queryClient);

export function ConvexClientProvider({ children }: { children: ReactNode }) {
  return (
    <ConvexAuthProvider client={convex}>
      <QueryClientProvider client={queryContext.queryClient}>
        {children}
      </QueryClientProvider>
    </ConvexAuthProvider>
  );
}
